module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "servicesRDV"
    }
  }, [_c('h2', [_vm._v(" Serices on appointment")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Surgery")]), _vm._v(" "), _c('p', [_vm._v("Soft tissue surgery")]), _vm._v(" "), _c('p', [_vm._v("Ovariectomy")]), _vm._v(" "), _c('p', [_vm._v("Castration")]), _vm._v(" "), _c('p', [_vm._v("Dental care")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Consultation")]), _vm._v(" "), _c('p', [_vm._v("A global approach based on nutrition and behavior\n          to achieve together the welfare of your companion.")]), _vm._v(" "), _c('p', [_vm._v("Homeopathic consultations")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Technical platform")]), _vm._v(" "), _c('p', [_vm._v("Ultrasound")]), _vm._v(" "), _c('p', [_vm._v("Radiography")]), _vm._v(" "), _c('p', [_vm._v("Hematology")]), _vm._v(" "), _c('p', [_vm._v("Biochemistry")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cc6dd99"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/En/ServicesRDV.vue
// module id = 117
// module chunks = 0